import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Detail_Ozo_Circle({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // SVG circular progress component
  const CircularProgress = ({ percentage }) => {
    const radius = 50;
    const strokeWidth = 7;
    const normalizedRadius = radius - strokeWidth * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDasharray = `${circumference} ${circumference}`;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
      <div className="position-relative d-flex justify-content-center align-items-center ">
        <svg height={radius * 2} width={radius * 2} style={{ transform: "rotate(-90deg)" }}>
          {/* Background circle */}
          <circle
            stroke="#F5F5F5"
            fill="transparent"
            strokeWidth={strokeWidth}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          {/* Progress circle */}
          <circle
            stroke="#23C5D3"
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeDasharray={strokeDasharray}
            style={{ strokeDashoffset }}
            //strokeLinecap="round"
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
        </svg>
        {/* Percentage text in center */}
        <div className="position-absolute d-flex flex-column justify-content-center align-items-center">
          <div
            className={"fw-semibold"}
            style={{ fontSize: "7px", color: "#999", marginTop: "4px", textAlign: "center" }}
          >
            Completed
          </div>
          <div style={{ fontSize: "14px", fontWeight: "bold", color: "#303030" }}>{percentage}%</div>
        </div>
      </div>
    );
  };

  return (
    <Row style={{ height: Number(item.height) }}>
      <div>
        {/* Sub scope name if exists */}

        <Row>
          <Col>
            <div style={{ fontSize: "20px", fontWeight: "600", color: "#092441" }}>{item.name}</div>
          </Col>
        </Row>
        {/* Three column layout */}
        <Row className="align-items-center">
          {/* Left - Title */}

          <Col>
            <div
              className="_scale-detail-text-pdf-new"
              style={{ fontSize: "11px", color: "#666", lineHeight: "1.1", textAlign: "justify" }}
              dangerouslySetInnerHTML={{ __html: item.lowSideText }}
            />
          </Col>

          {/* Center - Circular progress */}
          <Col xs={"auto"} className="d-flex justify-content-center">
            <CircularProgress percentage={elementScore} />
          </Col>

          <Col>
            <div
              className="_scale-detail-text-pdf-new"
              style={{
                fontSize: "11px",
                color: "#666",
                lineHeight: "1.1",
                textAlign: "justify",
                textAlignLast: "right",
              }}
              dangerouslySetInnerHTML={{ __html: item.highSideText }}
            />
          </Col>
        </Row>

        {/* Bottom section - Low and High side texts */}
        <Row className="mt-3">
          <Col>
            {item.generalInformationText?.length > 2 && (
              <div
                className={"text-center"}
                style={{ fontSize: "12px", color: "#666", lineHeight: "1.4" }}
                dangerouslySetInnerHTML={{ __html: item.generalInformationText }}
              />
            )}
          </Col>
        </Row>
      </div>
    </Row>
  );
}
